import React, { Fragment } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { baseMoment } from '../../helpers/dates';
import ScheduleListItem from '../ScheduleListItem';
import CustomPropTypes from '../../helpers/CustomPropTypes';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  rootCompact: {
    width: 512,
    padding: theme.spacing(3.5, 2.5),
    backgroundColor: theme.palette.common.white,
    borderRadius: 15,
    height: 'calc(100vh - 260px)',
    overflowY: 'scroll',
  },
  title: {
    fontSize: 32,
    fontFamily: 'Baskerville Old Face',
    textAlign: 'center',
    marginBottom: theme.spacing(5.5),
  },
  agendaDay: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '62px auto',
    columnGap: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
    },
    '& section': {
      [theme.breakpoints.down('sm')]: {
        borderRadius: 15,
      },
    },
    '&:first-child': {
      '& section': {
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        paddingTop: theme.spacing(0),
        [theme.breakpoints.down('sm')]: {
          paddingTop: theme.spacing(2),
          borderRadius: 15,
        },
      },
    },
    '&:last-child': {
      '& section': {
        borderBottomLeftRadius: 15,
        borderBottomRightRadius: 15,
        paddingBottom: theme.spacing(4.5),
        [theme.breakpoints.down('sm')]: {
          paddingBottom: theme.spacing(2),
          borderRadius: 15,
        },
      },
    },
  },
  agendaDayCompact: {
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: theme.palette.common.white,
  },
  agendaDate: {
    position: 'absolute',
    top: 6,
    fontSize: 17,
    color: theme.palette.lightGrey.main,
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      fontSize: 10,
    },
  },
  compactAgendaDateWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

  },
  agendaDateCompact: {
    marginRight: theme.spacing(2),
    position: 'static',
    fontSize: 14,
  },
  divider: {
    margin: theme.spacing(2.25, -3),
  },
  dividerCompact: {
    flex: 1,
    margin: theme.spacing(2.25, 0),
  },
  listWrapper: {
    width: '100%',
    minWidth: 0,
    padding: theme.spacing(0, 3),
    backgroundColor: '#F1F2F1',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 0, 2, 7.5),
    },
  },
  listWrapperCompact: {
    paddingLeft: theme.spacing(10),
    backgroundColor: theme.palette.common.white,
    padding: 0,
  },
}));
const ScheduleList = ({ activities, compact }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const classes = useStyles();

  const orderedActivitiesByDay = Object.keys(activities).sort((a, b) => baseMoment(a).diff(baseMoment(b), 'day'));

  const orderedActivities = (dayActivities) => {
    const ordered = [...dayActivities].sort(
      (a, b) => baseMoment(a.startDate).diff(baseMoment(b.startDate), 'hour')
    );
    return ordered;
  };

  return (
    <>
      <div className={clsx(classes.root, compact && classes.rootCompact)}>
        {compact && (
          <Typography variant="h4" className={classes.title}>
            Agenda
          </Typography>
        )}
        {orderedActivitiesByDay.length > 0 && (
          orderedActivitiesByDay.map((day) => (
            <div
              className={clsx(classes.agendaDay, { [classes.agendaDayCompact]: compact })}
              key={day}
            >
              <div className={clsx({ [classes.compactAgendaDateWrapper]: compact })}>
                <Typography variant="body1" className={clsx(classes.agendaDate, compact && classes.agendaDateCompact)}>
                  {baseMoment(day).format('DD/MM')}
                </Typography>
                {compact && (
                  <Divider className={classes.dividerCompact} />
                )}
              </div>
              <section
                className={clsx(classes.listWrapper, { [classes.listWrapperCompact]: compact })}
              >
                {orderedActivities(activities[day]).map((activity, index) => (
                  <Fragment key={activity.id}>
                    {index === 0 && !isMobile && !compact
                      && <Divider className={classes.divider} /> }
                    <ScheduleListItem activity={activity} compact={compact} />
                  </Fragment>
                ))}
              </section>
            </div>
          )))}
      </div>
    </>
  );
};

ScheduleList.propTypes = {
  compact: PropTypes.bool,
  activities: PropTypes.objectOf(
    PropTypes.arrayOf(
      CustomPropTypes.workshop
    )
  ),
};

ScheduleList.defaultProps = {
  activities: {},
  compact: false,
};

const mapStateToProps = ({ entities: { events } }) => ({ events });

export default connect(mapStateToProps)(ScheduleList);
